import "./style.scss"

import 'master';
import 'slick-carousel';

var  _isPopupClass = 'isPopup';

$(function() {
    googleMapPopFn();
    
});

function googleMapPopFn() {
    
    var $parent = $('.clubPart');
    $('.btn-close', $parent).click(function() {
      $parent.fadeOut();
    });
    // $('.clubInfo .arrowLink', $parent).click(function() {
    //     console.log("here")
    //     event.preventDefault();
    //   //popupGMFn();
    // });    
   
    $('.clubItem .arrowLink').each(function(i) {        
        $(this).bind('click', function() {
            event.preventDefault();            
            var tempGMLink = $(this).attr('href');
            popupGMFn();
            $('.googleMapPop').html('');
            setTimeout(function () {
                $('.googleMapPop').append('<iframe frameborder="0" style="border:0" src="' + tempGMLink + '"></iframe>');                
            }, 500);
        })
    })
    $('.module-popup-event .btn-close').click(function() {
        popupGMFn();
    });
  }
  
  function popupGMFn() {
    if (!$('html').hasClass(_isPopupClass)) {
      $('html').addClass(_isPopupClass);
      $('.popup-goggleMap').addClass('on');
    } else {
      $('html').removeClass(_isPopupClass);
      $('.popup-goggleMap').removeClass('on');
    }
  }